import React, { useRef } from "react";
import { Row, Col } from "react-bootstrap";
import FileUploader from "components/FileUploader/FileUploader";
import { ArchivosManager } from "managers/ECF/archivos.manager";
import useExceptionHandler from "hooks/useExceptionHandler";
import useMessage from "hooks/useMessage";
import { useTheme } from "hooks/useTheme";

const PlantillaStep = ({
  tipo,
  onArchivoSeleccionado,
  showLoading,
  hideLoading,
  disabled,
}) => {
  const { handleException } = useExceptionHandler();
  const { Warning } = useMessage();
  const { theme } = useTheme();
  const archivoRef = useRef(null);

  const handleDescargarPlantilla = () => {
    showLoading && showLoading();
    const link = document.createElement("a");
    link.target = "_blank";
    ArchivosManager.descargarPlantilla(tipo)
      .then((blob) => {
        link.href = URL.createObjectURL(blob);
        link.click();
      })
      .catch((e) => handleException(e))
      .finally(() => hideLoading && hideLoading());
  };

  const handleArchivoSeleccionado = (files) => {
    if (!files || files.length === 0) return;
    const archivo = files[0];

    const ext = archivo.name.split(".").pop().toLowerCase();
    if (ext !== "xls" && ext !== "xlsx") {
      Warning({ message: "Solo se aceptan archivos Excel (.xls o .xlsx)" });
      return;
    }

    // Pasamos el array tal cual: ArchivosManager.cargarArchivo / postWithFiles
    // requieren `Files` como array (postWithFiles llama data.Files.map(...)).
    onArchivoSeleccionado(files);
  };

  const stepCircle = (numero) => (
    <div
      style={{
        width: 28,
        height: 28,
        borderRadius: "50%",
        background: theme.color1,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        fontSize: "0.8rem",
        flexShrink: 0,
        marginRight: 10,
      }}
    >
      {numero}
    </div>
  );

  return (
    <div>
      <Row className="g-3 align-items-stretch">
        <Col md={5}>
          <div
            className="h-100 p-4"
            style={{ border: "1px solid #dee2e6", borderRadius: 8 }}
          >
            <div className="d-flex align-items-center mb-3">
              {stepCircle(1)}
              <span style={{ fontWeight: 600, fontSize: "0.95rem" }}>
                Descarga la plantilla
              </span>
            </div>
            <p
              className="text-muted mb-4"
              style={{ fontSize: "0.85rem", lineHeight: 1.6 }}
            >
              Descarga el archivo Excel con las columnas requeridas y complétalo
              con tus datos.
            </p>
            <div style={{ "--file-uploader-color": theme.color1 }}>
              <button
                type="button"
                className="StyledUploadButton"
                onClick={handleDescargarPlantilla}
                disabled={disabled}
                style={{ width: "100%" }}
              >
                <i className="fas fa-file-download" />
                <span>Descargar Plantilla</span>
              </button>
            </div>
          </div>
        </Col>

        <Col
          md={2}
          className="d-none d-md-flex align-items-center justify-content-center"
        >
          <i
            className="fas fa-arrow-right"
            style={{ fontSize: "1.3rem", color: "#adb5bd" }}
          />
        </Col>

        <Col md={5}>
          <div
            className="h-100 p-4"
            style={{ border: "1px solid #dee2e6", borderRadius: 8 }}
          >
            <div className="d-flex align-items-center mb-3">
              {stepCircle(2)}
              <span style={{ fontWeight: 600, fontSize: "0.95rem" }}>
                Carga el archivo completado
              </span>
            </div>
            <p
              className="text-muted mb-3"
              style={{ fontSize: "0.85rem", lineHeight: 1.6 }}
            >
              Selecciona el archivo Excel que completaste. Se aceptan los
              formatos <strong>.xls</strong> y <strong>.xlsx</strong>.
            </p>
            <div style={{ "--file-uploader-color": theme.color1 }}>
              <FileUploader
                ref={archivoRef}
                label="Cargar Plantilla"
                updateFilesCb={handleArchivoSeleccionado}
                maxSize={10 * 1024 * 1024}
                multiple={false}
                documentType="Document"
                fullWidth
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default PlantillaStep;
